/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看订单是否支付成功
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PayStatusParams {
  constructor(
    public orderId?: string,
    public orderType?:
      | "RECHARGE"
      | "SHOW"
      | "COMMODITY"
      | "VIDEO"
      | "ACTIVITYAPPLY"
  ) {}
}

export default async function (
  params: PayStatusParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/status`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
